







































import { Vue, Component, Prop } from 'vue-property-decorator';

import ChevronRightSolid from '~/components/icons/ChevronRightSolid.vue';
import ProviderCard from '~/components/cards/ProviderCard.vue';
import GlobalSwiper from '~/components/partials/GlobalSwiper.vue';
import MapOutline from '~/components/icons/MapOutline.vue';

@Component({
  components: { ChevronRightSolid, ProviderCard, MapOutline, GlobalSwiper },
})
export default class ProvidersFeed extends Vue {
  @Prop(Array) providers: Array<Types.Provider>;
  @Prop(String) customTitle: '';
  @Prop({ type: Boolean, default: true }) showAllLinks: boolean;
  @Prop(String) linkToExplorer: '';

  /* Skeleton length of fake cards to display based on user's window device */
  get skeletonLength () {
    if (process.client) {
      if (window.innerWidth < 1024 && window.innerWidth >= 768) return 3;
      return window.innerWidth < 768 ? 1 : 4;
    }
    return 4;
  }
}
